import { useTranslation } from 'react-i18next';

export default function FeatureTable() {
  const { t } = useTranslation('home');

  const features = [
    { category: 'Sneakers', update: t('comparison_daily'), quality: t('comparison_high'), popularity: '🔥 Alta' },
    { category: 'Streetwear', update: t('comparison_weekly'), quality: t('comparison_high'), popularity: '🔥 Alta' },
    { category: 'Luxury', update: t('comparison_weekly'), quality: t('comparison_medium'), popularity: 'Média' },
    { category: 'Acessórios', update: t('comparison_weekly'), quality: t('comparison_high'), popularity: 'Alta' },
    { category: 'Esportivo', update: t('comparison_daily'), quality: t('comparison_high'), popularity: '🔥 Alta' },
  ];

  return (
    <section className="relative w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            {t('feature_title')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t('feature_subtitle')}
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl p-6 md:p-8 overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-secondary-200">
                <th className="text-left py-3 px-4 text-xs md:text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  {t('feature_col_category')}
                </th>
                <th className="text-center py-3 px-4 text-xs md:text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  {t('feature_col_update')}
                </th>
                <th className="text-center py-3 px-4 text-xs md:text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  {t('feature_col_quality')}
                </th>
                <th className="text-center py-3 px-4 text-xs md:text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  {t('feature_col_popularity')}
                </th>
              </tr>
            </thead>
            <tbody>
              {features.map((f) => (
                <tr key={f.category} className="border-b border-secondary-100 last:border-0 hover:bg-background-100 transition-colors">
                  <td className="py-3.5 px-4">
                    <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                      {f.category}
                    </span>
                  </td>
                  <td className="py-3.5 px-4 text-center">
                    <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                      {f.update}
                    </span>
                  </td>
                  <td className="py-3.5 px-4 text-center">
                    <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                      {f.quality}
                    </span>
                  </td>
                  <td className="py-3.5 px-4 text-center">
                    <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                      {f.popularity}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}